import request from '@/utils/request'

// 获取设备历史采集数据
export const getDeviceRecord = (data) => {
    return request({
        url: '/heating/report_data/lists',
        params: data
    })
}

// 获取设备历史采集数据
export const getDeviceChart = (data) => {
    return request({
        url: '/heating/report_data/statistics',
        params: data
    })
}

// 获取多个设备最新采集数据
export const getDevicesRecord = (data) => {
    return request({
        url: '/heating/report_data/devices',
        method: 'POST',
        data
    })
}

// 获取告警日志列表
export const getAlarmLogList = (data) => {
    return request({
        url: '/heating/alarm/lists',
        params: data
    })
}

// 数据推送 - 获取列表
export const getPushSetList = (data) => {
    return request({
        url: '/heating/push_setting/lists',
        params: data
    })
}

// 数据推送 - 修改
export const updatePushSet = (data) => {
    return request({
        url: '/heating/push_setting/manage',
        method: 'POST',
        data
    })
}
// 删除报警记录
export const deleteAlarmLog = (id) => {
    return request({
        url: `/heating/alarm/${id}`,
        method: 'DELETE'
    })
}
